export default __webpack_public_path__ + "static/media/thin-edit.2da0fcfe.svg";